'use strict';

import storage from './storage';

const hatch: Hatch = {

  lang: '',
  hatchInitCount: 0,

  /**
   * Init hatch
   * Launch Hatch init if the script has been loaded
   */
  initHatch() {
    if (window.Hatch) {
      if (typeof window.Hatch.init === 'function') {
        console.log('Init hatch');
        window.Hatch.init();
      } else {
        // window.Hatch is missing init method > wait and try again
        let self = this;
        self.hatchInitCount = (typeof self.hatchInitCount === 'undefined' ? 0 : self.hatchInitCount);
        if (self.hatchInitCount < 4) {
          self.hatchInitCount += 1;
          setTimeout(function () {
            console.log('Waiting for Hatch...');
            if (self.initHatch) self.initHatch();
          }, 1000);
        }
      }
    }
  },

  /**
   * Insert hatch script to the page
   * @returns {boolean}
   */
  insertHatch() {
    if (document.getElementById('hatch-script')) return;
    let js, t = document.getElementsByTagName('script')[0];
    js = document.createElement('script');
    js.id = 'hatch-script';
    js.setAttribute('async', '');
    js.src = window.hatchScriptUrl;
    t.parentNode?.insertBefore(js, t);
    this.initHatch();
  },

  /**
   * Hatch script insert logic
   * If hatch is active for the country, insert hatch script.
   * Check locale restrictions if hatchByLocale has been set
   * -> Query locationServices for GeoIP or coordinates based restrictions
   */
  async init() {

    this.lang =  document.documentElement.lang || '';
    const self = this;

    if (!window.hatchByLocale) {
      console.log('Hatch: no special area restrictions set for country');
      if (this.insertHatch) this.insertHatch();
    } else {
      const hatchByLocale = storage.session ? sessionStorage.getItem('hatchByLocale') : null;

      console.log('Hatch: using area restrictions for country');
      console.log(`Hatch: hatchByLocale: ${hatchByLocale}`);

      if (hatchByLocale) {
        console.log(`Hatch: Saved value: ${hatchByLocale}`);
        if (hatchByLocale === 'true') {
          if (this.insertHatch) this.insertHatch();
        }
      } else if (hatchByLocale === null) {
        let coords;
        await navigator.permissions.query({ name: 'geolocation' }).then(function(result) {

          const onLocationFetchSuccess = (position) => {
            coords = position.coords;

            fetch(
              `/stage-ajax/locationServices/?stage-language=${self.lang}&service=hatch${coords ? `&lat=${coords.latitude}&lon=${coords.longitude}` : ''}`,
              { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
              .then(response => response.json())
              .then(data => {
                console.log(`Hatch: Hatch status: ${data.active}`);
                if (sessionStorage) {
                  sessionStorage.setItem('hatchByLocale', data.active);
                }
                if (data.active) {
                  if (self.insertHatch) self.insertHatch();
                } else {
                  self.insertHatch = undefined;
                }
              }).catch(_ => {
                console.log('Hatch: error fetching.');
                self.insertHatch = undefined;
              });
          };

          const onLocationFetchFailure = (error = {}) => {
            console.log('Hatch: Geolocation permission denied', error);
          };

          navigator.geolocation.getCurrentPosition(onLocationFetchSuccess, onLocationFetchFailure);

          if (result.state === 'denied') {
            onLocationFetchFailure();
          }

          // This will still work for Chrome
          result.onchange = function() {
            if (result.state === 'denied') {
              onLocationFetchFailure();
            }
          }
        });

      }
    }
  }
};

interface Hatch {
  lang: string;
  hatchInitCount: number;
  initHatch: () => void;
  insertHatch?: () => void;
  init: () => void;
}


declare global {
  interface Window {
    hatchByLocale?: boolean;
    hatchScriptUrl?: string;
  }
}


export default hatch;
